import { APP_INITIALIZER } from '@angular/core';
import { TranslateLangService } from 'app/services/core/translate-lang.service';
// import { TranslateLangService } from '@shared/services/translate-lang.service';

export function TranslateLangServiceFactory(translateLangService: TranslateLangService) {
  return () => translateLangService.load();
}

export const appInitializerProviders = [
  {
    provide: APP_INITIALIZER,
    useFactory: TranslateLangServiceFactory,
    deps: [TranslateLangService],
    multi: true,
  }
];
